/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Modal from "./Modal";

const Header = (props) => {
  const { setCurrentComponentIndex = () => { } } = props || {};
  const location = useLocation();
  const isHomePage = location.pathname === "/home" || location.pathname === "/investors" || location.pathname === "/eira-avatar" || location.pathname === "/programs/specific-programs" || location.pathname === "/services/personalized-programs" || location.pathname === "/privacy" || location.pathname === "/term";
  const [isOpen, setIsOpen] = useState(false);

  const openSlideMenu = () => {
    setIsOpen(true);
  };

  const closeSlideMenu = () => {
    setIsOpen(false);
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <div>
        {/* Main content */}
        <div className="main_header">
          <div id="content">
            <span className="d-flex justify-content-between">
              <a href="#" onClick={openSlideMenu} className="menu-link d-flex">
                <div className="menu-icon-container">
                  <span className="menu-icon">☰</span>{" "}
                </div>
                <p
                  className="menu-description"
                  style={{ color: isHomePage ? "black" : "white" }}
                >
                  MENU
                </p>
              </a>

              <Link className="logo" to={"/"}>
                <p
                  className="text_16_header"
                  style={{ color: isHomePage ? "black" : "white" }}
                >
                  IMMSY
                </p>
              </Link>

              <Link className="logo" to={"/"}>
                <p
                  className="text_16_header_button"
                  onClick={openModal}
                >
                  JOIN WAITLIST
                </p>
              </Link>
            </span>

            {/* Sidebar */}
            <div id="menu" className={`nav ${isOpen ? "open" : ""}`}>
              <a href="#" className="close" onClick={closeSlideMenu}>
                <i className="fas fa-times"></i>
              </a>
              <div className="menu_item">
                <div className="dropdown" onClick={() => setCurrentComponentIndex(0)}>
                  <Link to={"/"}>Home</Link>
                </div>
                <div className="dropdown">
                  <Link to={"/about-us"}>About Us</Link>
                </div>
                <div className="dropdown">
                  <Link to={"/programs/specific-programs"}>Programs Menu</Link>
                  {/* <div className="dropdown-content">
                    <Link to={"/programs/specific-programs"}>Specific Programs</Link>
                    <Link to={"/programs/user-profiles"}>User Profiles</Link>
                    <Link to={"/programs/library-overview"}>Library Overview</Link>
                    <Link to={"/programs/corporate-wellness"}>Corporate Wellness Programs</Link>
                    <Link to={"/programs/fitness-wellness"}>Fitness and Wellness Programs</Link>
                    <Link to={"/programs/mental-health"}>Mental Health Programs</Link>
                    <Link to={"/programs/sports-athletics"}>Sports and Athletics Programs</Link>
                    <Link to={"/programs/nutrition"}>utrition Programs</Link>
                    <Link to={"/programs/education"}>Education Programs</Link>
                  </div> */}
                </div>
                <div className="dropdown">
                  <Link to={"/services/personalized-programs"}> Services</Link>
                  {/* <div className="dropdown-content">
                    <Link to={"/services/personalized-programs"}> Personalized Programs</Link>
                    <Link to={"/services/real-time-health-monitoring"}>Real-Time Health Monitoring</Link>
                    <Link to={"/services/immersive-retreats"}>Immersive Retreats</Link>
                    <Link to={"/services/secure-health-data-management"}>Secure Health Data Management</Link>
                    <Link to={"/services/ai-powered-virtual-counselor"}>AI-Powered Virtual Counselor</Link>
                    <Link to={"/services/content-and-services-library"}>Content and Services Library</Link>
                    <Link to={"/services/advanced-bloodwork-analysis"}>Advanced Bloodwork Analysis</Link>

                  </div> */}
                </div>
                <Link to={"/programs/specific-programs"}> Immersive Wellness Retreats</Link>
                <Link to={"/how-it-works"}> How It Works</Link>
                <Link to={"/investors"}>Investor Section</Link>

                <div className="ploicy_term">
                  <Link to={"/privacy"}> Privacy policy</Link>
                  <Link to={"/term"}>Terms & conditions</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Header;


